import {ColorSchemeType} from 'platform/components';
import {match} from 'ts-pattern';

import {always, isNil} from 'ramda';

import {RentalOrderResponseBody} from '@dms/api/rental';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {Nullish} from 'shared/web';

export type RentalOrderState = RentalOrderResponseBody['state'] | Nullish;
export const getRentalOrderStateFlag = (state: RentalOrderState) =>
  match<RentalOrderState, {colorScheme: ColorSchemeType; label: string; 'data-testid': string}>(
    state
  )
    .when(
      isNil,
      always({
        colorScheme: 'neutral',
        label: i18n.t('page.rentalOrder.labels.draft'),
        'data-testid': testIds.rentalOrder.detail('state'),
      })
    )
    .with(
      'reserved',
      always({
        colorScheme: 'orange',
        label: i18n.t('page.rentalOrder.labels.reserved'),
        'data-testid': testIds.rentalOrder.detail('state'),
      })
    )
    .with(
      'rented',
      always({
        colorScheme: 'blue',
        label: i18n.t('page.rentalOrder.labels.rented'),
        'data-testid': testIds.rentalOrder.detail('state'),
      })
    )
    .with(
      'returned',
      always({
        colorScheme: 'purple',
        label: i18n.t('page.rentalOrder.labels.returned'),
        'data-testid': testIds.rentalOrder.detail('state'),
      })
    )
    .with(
      'closed',
      always({
        colorScheme: 'green',
        label: i18n.t('page.rentalOrder.labels.closed'),
        'data-testid': testIds.rentalOrder.detail('state'),
      })
    )
    .with(
      'draft',
      always({
        colorScheme: 'neutral',
        label: i18n.t('page.rentalOrder.labels.draft'),
        'data-testid': testIds.rentalOrder.detail('state'),
      })
    )
    .with(
      'canceled',
      always({
        colorScheme: 'red',
        label: i18n.t('page.rentalOrder.labels.cancelled'),
        'data-testid': testIds.rentalOrder.detail('state'),
      })
    )
    .exhaustive();
